
import Vue, { PropType } from 'vue'
import { lastModifiedDisplay, sizeDisplay } from '@/services/files'
import { archiveExtensions } from '@/config'
import RIcon from '@/components/icons/index.vue'
import { RCheckbox } from '@/components/'
import { FileBrowserDirectory, FileBrowserFile, SharedBrowserItem } from './types'

type Ext = 'archive' | 'unknown'

export default Vue.extend({
  name: 'FileBrowserItem',
  props: {
    item: {
      type: Object as PropType<FileBrowserFile | FileBrowserDirectory | SharedBrowserItem>,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShared: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RIcon,
    RCheckbox,
  },
  computed: {
    isFile(): boolean {
      return this.item.type === 'file' && this.ext === 'unknown'
    },
    isDir(): boolean {
      return this.item.type === 'dir'
    },
    ext(): Ext {
      const { name } = this.item
      if (archiveExtensions.some((suffix: string) => name.endsWith(suffix))) {
        return 'archive'
      } else {
        return 'unknown'
      }
    },
    isArchive(): boolean {
      return this.ext === 'archive'
    },
    isSelected(): boolean {
      return this.item.selected
    },
    lastModified(): string {
      const ms_timestamp =
        (this.item as FileBrowserFile).lastModified ||
        (this.item as SharedBrowserItem).last_modified_ms_timestamp
      return lastModifiedDisplay(ms_timestamp)
    },
    size(): string {
      const size =
        (this.item as FileBrowserFile).size || (this.item as SharedBrowserItem).size_in_bytes
      return sizeDisplay(size)
    },
    name(): string | undefined {
      if (this.isShared) {
        return (this.item as SharedBrowserItem).name.split('/').pop()
      }
      return (this.item as FileBrowserFile).name
    },
  },
  methods: {
    click() {
      if (this.disabled) return
      const { selected } = this.item
      const name = (this.item as FileBrowserFile).s3Path || this.item.name
      if (selected) {
        this.$emit('deselect-item', name)
      } else {
        this.$emit('select-item', name)
      }
    },
    doubleclick() {
      if (this.disabled) return
      if (this.isDir) {
        const path = (this.item as FileBrowserFile).s3Path || this.item.name
        this.$emit('go-to', path)
      } else {
        // it's a file, we could do something here in the future if needed
      }
    },
  },
})
